<template>
    <div class="fhv-centent">
        <h4 class="title-topic">WIFI Advanced Settings 2.4GHz</h4>
        <el-alert title="Some parameters in subRouter mode are forbidden to be modified!" type="warning" show-icon
        :closable="false" v-if="$G_DEVICE_CFG.isSubRouter"></el-alert>
        <el-form 
        :model="wlform"  
        label-width="180px" 
        label-position="left"
        class="fhv-form" 
        size="mini"
        :rules="formCheck" 
        ref="wlform"
        :disabled="$G_DEVICE_CFG.isReadOnly || $G_DEVICE_CFG.isSubRouter"
        v-loading="getLoad"
        >
            <el-form-item label="Mode :">
                <el-tooltip :disabled="!$G_DEVICE_CFG.isFindSubRouter" effect="dark" popper-class="wring-text"  placement="top" 
                content="Modifying this parameter may cause the subRouter network to be down. Prohibit operation!">
                    <el-select v-model="wlform.band" style="width: 100%" placeholder="Please select Mode" 
                    :disabled="$G_DEVICE_CFG.isFindSubRouter">
                        <el-option label="802.11b" value="1"></el-option>
                        <el-option label="802.11g" value="2"></el-option>
                        <el-option label="802.11n" value="8"></el-option>
                        <el-option label="802.11b/g" value="3"></el-option>
                        <el-option label="802.11g/n" value="10"></el-option>
                        <el-option label="802.11b/g/n" value="11"></el-option>
                    </el-select>
                </el-tooltip>
            </el-form-item>
            <el-form-item label="Bandwidth :" >
                <el-tooltip :disabled="!$G_DEVICE_CFG.isFindSubRouter" effect="dark" popper-class="wring-text"  placement="top" 
                content="Modifying this parameter may cause the subRouter network to be down. Prohibit operation!">
                <el-select v-model="wlform.bandwidth" style="width: 100%" placeholder="Please select Bandwidth" 
                :disabled="$G_DEVICE_CFG.isFindSubRouter || !is8011N">
                    <el-option label="20 MHz" value="0"></el-option>
                    <el-option label="40 MHz" value="1"></el-option>
                    <el-option label="20/40 MHz" value="3"></el-option>
                </el-select>
                </el-tooltip>
            </el-form-item>
            <el-form-item label="Control Sideband :" v-if="isShowControlSideband">
                <el-tooltip :disabled="!$G_DEVICE_CFG.isFindSubRouter" effect="dark" popper-class="wring-text"  placement="top" 
                content="Modifying this parameter may cause the subRouter network to be down. Prohibit operation!">
                <el-select v-model="wlform.controlSideband" style="width: 100%" placeholder="Please select Control Sideband" 
                 :disabled="$G_DEVICE_CFG.isFindSubRouter">
                    <el-option label="Upper" value="0"></el-option>
                    <el-option label="Lower" value="1"></el-option>
                </el-select>
                </el-tooltip>
            </el-form-item>
            <el-form-item label="Channel :" >
                <el-tooltip :disabled="!$G_DEVICE_CFG.isFindSubRouter" effect="dark" popper-class="wring-text"  placement="top" 
                content="Modifying this parameter may cause the subRouter network to be down. Prohibit operation!">
                <el-select v-model="wlform.channel" style="width: 100%" placeholder="Please select Transmit Power">
                    <el-option :label="wlform.channel !== '0' ? 'auto' : autoText" value="0"></el-option>
                    <el-option v-for="channelNum in channelNumArr" :key="channelNum" :label="channelNum" :value="channelNum"></el-option>
                </el-select>
                </el-tooltip>
            </el-form-item>
            <!-- 哥伦比亚版本功率配置在基本配置页面 -->
            <el-form-item label="Transmit Power :" v-if="!$isCLARO"> 
                <el-select v-model="wlform.power" 
                @change="tipReboot"
                style="width: 100%" placeholder="Please select Transmit Power" >
                    <el-option v-if="$isAis" label="Optimized (default)" value="0"></el-option>
                    <el-option v-else label="Standard" value="0"></el-option>
                    <el-option label="Medium" value="1"></el-option>
                    <el-option label="High" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Beacon Interval :" prop="beaconInterval">
                <el-input v-model="wlform.beaconInterval"></el-input>
            </el-form-item>
            <el-form-item label="RTS Threshold :" prop="rtsThreshold">
                <el-input v-model="wlform.rtsThreshold"></el-input>
            </el-form-item>
            <el-form-item label="Fragment Threshold :" prop="fragThreshold">
                <el-input v-model="wlform.fragThreshold"></el-input>
            </el-form-item>
            <el-form-item label="Maxinum Clients  :" prop="maxinumClients">
                <el-input v-model="wlform.maxinumClients"></el-input>
            </el-form-item>
            <el-form-item label="DTIM Interval  :" prop="dtimPeriod">
                <el-input v-model="wlform.dtimPeriod"></el-input>
            </el-form-item>
            <el-form-item label="Roaming Enable :">
                <el-switch v-model="wlform.roamEnable"></el-switch>
            </el-form-item>
            <el-form-item label="Short GI :">
                <el-switch v-model="wlform.shortGI"></el-switch>
            </el-form-item>
            <el-form-item label="WMM :">
                <el-switch v-model="wlform.wmmEnabled"></el-switch>
            </el-form-item>
            <el-form-item label="WMM APSD :">
                <el-switch v-model="wlform.uapsdEnabled"></el-switch>
            </el-form-item>
            <el-form-item label="Adaptivity Enable :">
                <el-switch v-model="wlform.adaptivityEnable"></el-switch>
            </el-form-item> 
            <el-form-item label="ATF Enable :">
                <el-switch v-model="wlform.ATFEnable"></el-switch>
            </el-form-item>
            <el-form-item label="TXBF Enable :">
                <el-switch v-model="wlform.TXBFEnable"></el-switch>
            </el-form-item> 
            <el-form-item>
                <el-button type="primary" @click="apply">Apply</el-button>
                <el-button type="primary" @click="refresh">Refresh</el-button>
            </el-form-item>
        </el-form>
    </div>
    
</template>

<script>
import Reboot from '@/components/reboot.js'
import validator from 'validator'
import devConfig from '@/devConfig'

let powerCache = '0'; // 当前配置 power
export default {
    data(){
       return {
           getLoad:false,
           isShowControlSideband:false,
           autoText:'auto',
           wlform:{
                band: "11",
                bandwidth: "3",
                beaconInterval: 100,
                channel: "0",
                controlSideband: "0",
                dtimPeriod: 1,
                fragThreshold: 2346,
                maxinumClients: 32,
                power: "0",
                rtsThreshold: 2347,
                shortGI: true,
                uapsdEnabled: true,
                wmmEnabled: true,
                roamEnable: true,
                adaptivityEnable:false,
                ATFEnable:false,
                TXBFEnable:false
           },
           formCheck:{
                beaconInterval:[
                    { required: true, message: 'Beacon interval cannot be empty.', trigger: 'blur' },
                    {
                        validator:(rule, value, callback) => {
                            if(!validator.isInt(value+'',{min: 20, max: 1024}))
                                callback(new Error('Beacon interval is an integer and  range [20-1024].'));
                            else
                                 callback()
                        },
                        trigger: 'blur'
                    }
                ],
                dtimPeriod:[
                    { required: true, message: 'DTIM Interval cannot be empty.', trigger: 'blur' },
                    {
                        validator:(rule, value, callback) => {
                            if(!validator.isInt(value+'',{min: 1, max: 255}))
                                callback(new Error('DTIM Interval is an integer and  range [1-255].'));
                            else
                                 callback()
                        },
                        trigger: 'blur'
                    }
                ],
                fragThreshold:[
                    { required: true, message: 'Fragment Threshold cannot be empty.', trigger: 'blur' },
                    {
                        validator:(rule, value, callback) => {
                            if(!validator.isInt(value+'',{min: 1, max: 2346}))
                                callback(new Error('Fragment Threshold is an integer and  range [1-2346].'));
                            else
                                 callback()
                        },
                        trigger: 'blur'
                    }
                ],
                maxinumClients:[
                    { required: true, message: 'Maxinum Clients cannot be empty.', trigger: 'blur' },
                    {
                        validator:(rule, value, callback) => {
                            if(!validator.isInt(value+'',{min: 1, max: 32}))
                                callback(new Error('Maxinum Clients is an integer and  range [1-32].'));
                            else
                                 callback()
                        },
                        trigger: 'blur'
                    }
                ],
                rtsThreshold:[
                    { required: true, message: 'RTS Threshold cannot be empty.', trigger: 'blur' },
                    {
                        validator:(rule, value, callback) => {
                            if(!validator.isInt(value+'',{min: 1, max: 2347}))
                                callback(new Error('Maxinum Clients is an integer and  range [1-2347].'));
                            else
                                 callback()
                        },
                        trigger: 'blur'
                    }
                ],
           } 
       }
    },
    created(){
        devConfig.init(this,()=>{
            this.getData()
        })
    },
    computed:{
        is8011N(){
            if(this.wlform.band === '8' || this.wlform.band === '10' || this.wlform.band === '11')
            {// 802.11n
                return true
            }
            else
            {// 非802.11n 频宽 为20MHz
                this.wlform.bandwidth = '0'
                return false
            }
        },
        channelNumArr(){
            let channel =  ['1','2','3','4','5','6','7','8','9','10','11','12','13']

            // 巴西信道范围不一样
            if(this.$isBRAZIL || this.$isTRUE) channel =  ['1','2','3','4','5','6','7','8','9','10','11']

            let is8011N = false
            let nowChannelNum = parseInt(this.wlform.channel)
            this.isShowControlSideband = false
            if(this.wlform.band === '8' || this.wlform.band === '10' || this.wlform.band === '11')
                is8011N = true
            
            if(is8011N && this.wlform.bandwidth == '1' /*40 MHz*/) 
            {
                this.isShowControlSideband = true
                if(this.wlform.controlSideband === '0') 
                {//Upper
                    channel = ['5','6','7','8','9','10','11','12','13']
                    
                     // 巴西信道范围不一样
                    if(this.$isBRAZIL || this.$isTRUE) channel =  ['5','6','7','8','9','10','11']

                    if(nowChannelNum > 0 && nowChannelNum < 5)
                    {// 不在信道范围内则重置为AUTO
                        this.wlform.channel = '0'
                    }
                        
                }
                else
                {//Lower
                    channel = ['1','2','3','4','5','6','7','8','9']
                    if(nowChannelNum != 0 && nowChannelNum > 9)
                    {// 不在信道范围内则重置为AUTO
                        this.wlform.channel = '0'
                    }
                }
            }

            return channel
        }
    },
    methods:{
        getData(){
            this.getLoad = true
            axios
            .post("/boafrm/fhAdvancedWlan",{
                CmdType:"GET_ADVANCED_WLAN",
                ssidIndex:"0" // only SSID1
            })
            .then((response)=>{
                this.getLoad = false
                if(response.data.ret == '0')
                {
                    this.wlform.band = response.data.band
                    this.wlform.bandwidth = response.data.bandwidth
                    this.wlform.beaconInterval = response.data.beaconInterval
                    this.wlform.channel = response.data.channel
                    this.wlform.controlSideband = response.data.controlSideband
                    this.wlform.dtimPeriod = response.data.dtimPeriod
                    this.wlform.fragThreshold = response.data.fragThreshold
                    this.wlform.maxinumClients = response.data.maxinumClients
                    this.wlform.power = response.data.power
                    powerCache = response.data.power
                    this.wlform.rtsThreshold = response.data.rtsThreshold
                    this.wlform.shortGI = response.data.shortGI
                    this.wlform.uapsdEnabled = response.data.uapsdEnabled
                    this.wlform.wmmEnabled = response.data.wmmEnabled
                    this.wlform.roamEnable = response.data.roamEnable
                    this.wlform.adaptivityEnable = response.data.adaptivityEnable
                    this.wlform.ATFEnable = response.data.ATFEnable
                    this.wlform.TXBFEnable = response.data.TXBFEnable
                    this.autoText = `auto(${response.data.wlCurrentChannel})`
                }
            })
        },
        setData(){
            const loadingInstance = this.$loading({lock: true})
            axios
            .post("/boafrm/fhAdvancedWlan",{
                CmdType:"SET_ADVANCED_WLAN",
                ssidIndex:"0", // only SSID1
                band: this.wlform.band,
                bandwidth: this.wlform.bandwidth,
                beaconInterval: this.wlform.beaconInterval,
                channel: this.wlform.channel,
                controlSideband: this.wlform.controlSideband,
                dtimPeriod: this.wlform.dtimPeriod,
                fragThreshold: this.wlform.fragThreshold,
                maxinumClients: this.wlform.maxinumClients,
                power: this.wlform.power,
                rtsThreshold: this.wlform.rtsThreshold,
                shortGI: this.wlform.shortGI,
                uapsdEnabled: this.wlform.uapsdEnabled,
                wmmEnabled: this.wlform.wmmEnabled,
                roamEnable: this.wlform.roamEnable,
                adaptivityEnable: this.wlform.adaptivityEnable,
                ATFEnable:this.wlform.ATFEnable,
                TXBFEnable:this.wlform.TXBFEnable
            })
            .then((response)=>{
                setTimeout(()=>{
                    loadingInstance.close()
                    if(response.data.ret == '0')
                    {
                        if(powerCache !== this.wlform.power)
                        {
                            powerCache = this.wlform.power
                            this.$message.success("Configuration is successful! the device shall be restarted before it can take effect. If necessary, please restart the device manually.")
                        }
                        else
                        {
                            this.$message.success("Configuration is successful!")
                        }
                    }
                    else
                        this.$message.error("Configuration failed!")
                },6000)
            })
        },
        tipReboot(val){
            if(val !== powerCache)
            {
                this.$alert('To modify transmission power parameters, the device shall be restarted before it can take effect. If necessary, please restart the device manually.', 'Warning', {
                    confirmButtonText: 'Confirm',
                    type: 'warning'
                })
            }
        },
        apply(){
            this.$refs['wlform'].validate((valid) => {
                if (valid) {
                    this.setData()
                } else {
                    return false
                }
            })
        },
        refresh(){
            this.$refs['wlform'].resetFields()
            this.getData()
        },
    },
}
</script>

<style>
.fhv-password{
    cursor:pointer
}
.wring-text{
    color: #F56C6C;
}
</style>




